/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReferralStep {
    APPLYING = 'APPLYING',
    APPLIED = 'APPLIED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    SUBSCRIBED = 'SUBSCRIBED',
}
